import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { AttendanceCheck, AttendanceRecord } from "../../interfaces/attendance";

export type AttendanceWsEventType =
  | "ATTENDANCE_CHECKS_CREATED"
  | "ATTENDANCE_CHECK_UPDATED"
  | "ATTENDANCE_CHECK_DELETED"
  | "ATTENDANCE_CHECK_FINALIZED"
  | "ATTENDANCE_RECORD_UPDATED";

export interface AttendanceWsEvent {
  type: AttendanceWsEventType;
  groupId: string;
  body: {
    group_id: string;
    course_id?: string;
    group_name?: string;
    course_name?: string;
    check_id?: string;
    checks?: AttendanceCheck[];
    opens_at?: string;
    closes_at?: string;
    student_id?: string;
    record?: AttendanceRecord | null;
  };
}

@Injectable({
  providedIn: "root",
})
export class AttendanceRefreshService {
  private readonly eventsSubject = new Subject<AttendanceWsEvent>();

  readonly events$: Observable<AttendanceWsEvent> =
    this.eventsSubject.asObservable();

  emit(event: AttendanceWsEvent): void {
    this.eventsSubject.next(event);
  }
}
